// 小米负一屏小部件
export default {
  // 英语域名
  "en-wg.comfortweather.com": {
    ad3: [
      {
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 5403947099,
        style: {
          display: "inline-block",
          width: "320px",
          height: "50px",
        },
        position: "position-08",
      },
    ],
    ad1: [
      {
        // type: "adx",
        // id: "div-gpt-ad-1747137553356-0",
        // slot: "/22175678864/encomforweather_320*100_ad1",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1749802990735-0",
        // slot: "/22175678864/enwgcomforweather_320*100_ad1",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 5146341233,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-20",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1747137573149-0",
        // slot: "/22175678864/encomforweather_320*100_ad2",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        // type: "adx",
        // id: "div-gpt-ad-1749803024665-0",
        // slot: "/22175678864/enwgcomforweather_320*100_ad2",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        // type: "ads",
        // client: "ca-pub-2826423230659304",
        // slot: 7888054642,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 8189067855,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-08",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1749802990735-0",
        // slot: "/22175678864/enwgcomforweather_320*100_ad1",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        // type: "ads",
        // client: "ca-pub-2826423230659304",
        // slot: 8100641786,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "50px",
        // },

        type: "anchor",
        slot: "/22175678864/enwgcomforweather_320*50_xidi",
        position: "position-01",
      },
      {
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 7615193102,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-24",
      },
      {
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 2520177895,
        style: {
          display: "inline-block",
          width: "320px",
          height: "100px",
        },
        position: "position-26",
      },
    ],
    ad2: [
      {},
      {},
      {},
      {},
      {
        // <!--home-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 9012501806,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-21",
      },
    ],
  },
  // 印地语域名
  "hi-wg.comfortweather.com": {
    ad1: [],
    ad2: [],
  },
  // 印尼语域名
  "id-wg.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1747137287379-0",
        slot: "/22175678864/idcomforweather_320*100_ad1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-06",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1747137370092-0",
        slot: "/22175678864/idcomforweather_320*100_ad2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-07",
      },
    ],
    ad2: [],
  },
  // 西班牙语域名
  "es-wg.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1744196940149-0",
        slot: "/22175678864/ES_comfortweather_320*100_ad1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-06",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1744197165644-0",
        slot: "/22175678864/ES_comfortweather_320*100_ad2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-07",
      },
    ],
    ad2: [],
  },
  // 巴西-葡萄牙语
  "pt-br-wg.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1744268673918-0",
        slot: "/22175678864/BR_comfortweather_320*100_ad1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-06",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1744268787668-0",
        slot: "/22175678864/BR_comfortweather_320*100_ad2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-07",
      },
    ],
    ad2: [],
  },
  // 新增俄罗斯域名
  "rs-wg.comfortweather.com": {
    ad1: [
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175136551314947369",
        p1: "dikbn",
        p2: "jfhk",
        position: "position-06",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175136553684147369",
        p1: "dikbo",
        p2: "jfhk",
        position: "position-07",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175136551314947369",
        p1: "dikbn",
        p2: "jfhk",
        position: "position-01",
      },
    ],
    ad2: [],
  },
  // 小米天气新增负一屏的广告位需要新的域名进行投放。域名使用统一的链接带语言参数的方式。（可参考小部件的域名参数方式）
  "mos.comfortweather.com": {
    ad1: [
      {},
      {},
      {
        type: "anchor",
        slot: "/22175678864/enwgcomforweather_320*50_xidi2.0",
        position: "position-01",
      },
    ],
    ad2: [
      {
        // <!--now-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 3078422960,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-08",
      },
      {
        // <!--hourly-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 6131127565,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-11",
      },
      {
        // <!--daily：-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 8816984749,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-09",
      },
      {
        // <!--sun:-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 3504964222,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-10",
      },
      {
        // <!--home-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 5400192292,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-21",
      },
    ],
  },
};
